<template>
  <div>
    <div v-if="imageURL">
      <img
        alt="(sketch-image)"
        :src="imageURL"
        class="img-fluid mb-3 rounded"
        crossorigin="true"
      />
      <br />
      <button class="btn btn-link text-danger fw-bold" @click="removeImage">
        Remove Image
      </button>
      <!-- Allow cross origin from stackoverflow:
              https://stackoverflow.com/questions/42263223/how-do-i-handle-cors-with-html2canvas-and-aws-s3-images
               -->
    </div>
    <div v-else>
      <div class="text-middle fw-bold fs-4 bg-warning rounded-2">
        No image uploaded
      </div>

      <div
        v-if="showError"
        class="text-middle text-white fw-bold fs-3 bg-danger rounded-2 mb-3"
      >
        <i class="bi bi-exclamation-triangle-fill me-3"></i>Image file is too
        large. <i class="bi bi-exclamation-triangle-fill ms-3"></i><br />
        Please resize your image and try again.
      </div>

      <div v-if="!exportMode">
        <div class="card card-body bg-moondust mb-0 mt-3">
          <label :for="sketchUploadHeaders.imageKey"
            ><p class="fw-bold fs-5">
              {{ sketchUploadHeaders.subheader }}
            </p>
            Supported image file types:
            <b>JPEG, JPG, GIF, PNG, HEIC</b>. Images are limited to
            <b>15 MB</b>. Please resize your images prior to uploading if they
            are larger.</label
          >
          <p
            class=""
            v-html="
              renderFormatSuperscriptOrSubscript(
                sketchUploadHeaders.description
              )
            "
          ></p>
          <input
            :id="sketchUploadHeaders.imageKey"
            type="file"
            class="form-control"
            name="sketch"
            @change="changeImage($event)"
            :value="localImageURL"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetsAPI from "@/helpers/AssetsAPI";
import FormatAPI from "@/helpers/FormatAPI";

export default {
  name: "SketchUpload",
  mixins: [AssetsAPI, FormatAPI],
  data() {
    return {
      localImageURL: "",
      image: "",
      showError: false
    };
  },
  props: {
    imageURL: String,
    sketchUploadHeaders: Object,
    formId: Number,
    exportMode: Boolean
  },
  computed: {
    noSubmittedImage() {
      return this.imageURL === "" || this.imageURL === undefined;
    }
  },
  methods: {
    //...mapActions(["updateFormImageURL"]),
    // The following method is taken from the glossaryForm view:
    // https://github.com/osuecampus/glossary-v2/blob/8af82c92b5509a9f0ad785d36c6cdc866093f382/src/components/examples/GlossaryForm.vue
    changeImage(event) {
      this.showError = false;
      if (event.target.files[0]) {
        //
        // Check file size
        //
        const MB = 1024 * 1024; // 1MB
        const MB_LIMIT = 15 * MB; // 15MB - Based on Asset API

        if (event.target.files[0].size >= MB_LIMIT) {
          console.log("Size", event.target.files[0].size);
          this.showError = true;

          return false;
        }

        this.uploadImage(event.target.files[0], (imageURL) => {
          this.$emit("changeImage", {
            fieldName: this.sketchUploadHeaders.imageKey,
            imageURL: imageURL
          });
        });
      }
    },
    removeImage() {
      if (confirm("Are you sure you want to remove the image?")) {
        this.showError = false;

        this.$emit("changeImage", {
          fieldName: this.sketchUploadHeaders.imageKey,
          imageURL: ""
        });
      }
    }
  }
};
</script>

<style scoped>
img {
  max-width: 100%; /* Ensure the image fits its container width */
  height: auto; /* Maintain aspect ratio */
}
</style>
